export default "__VITE_ASSET__DINVk1qn__"